export enum Tab {
  None = 0,
  Home = 1,
  Business = 2,
  Account,
  Admin,
}